/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars, jsx-a11y/no-static-element-interactions, no-console, no-nested-ternary, jsx-a11y/click-events-have-key-events */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import {
  Col,
  Row,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';
import { ErrorMessage, Formik, FormikProps } from 'formik';
import * as Yup from 'yup';
import CreatableSelect from 'react-select/creatable';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import prototypeApi from '../../../api/prototypeApi';
import FormikControl from '../../../components/common/FormikControl';
import TextError from '../../../components/common/TextError';
import SelectLists from '../data';
import DragAndDropField from '../../../components/FormFields/DragAndDropField';

const AddPrototype: React.FC<any> = (props: {
  match: {
    params: { prototypeId: string; view: boolean };
  };
  history: any;
  onClose?: () => void;
  toggle: () => void;
}) => {
  const {
    match: {
      params: { prototypeId, view },
    },
    history,
    onClose,
    toggle,
  } = props;
  const formikRef = useRef<FormikProps<any>>(null);

  const [isUpload, setIsUpload] = useState<boolean>(true);
  const [prototypeView, setPrototypeView] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<{
    name: string | any;
    image: string | any;
    tier: string | any;
    stage: string | any;
    platform: string | any;
    strategySessionDate: Date | any;
    cms: string | any;
    launchDate: Date | any;
    hardLaunchDate: boolean;
    estDevStart: Date | any;
    comment: string | any;
    projectSOW: string | any;
    designSpec: string | any;
    techSpec: string | any;
    USPM: string | any;
    SLPM: string | any;
    BA: string | any;
  }>({
    name: '',
    image: '',
    tier: '',
    stage: '',
    strategySessionDate: '',
    platform: '',
    cms: '',
    launchDate: '',
    hardLaunchDate: false,
    estDevStart: '',
    comment: '',
    projectSOW: '',
    designSpec: '',
    techSpec: '',
    USPM: '',
    SLPM: '',
    BA: '',
  });

  const onSubmit = async (values: any, submitProps: any) => {
    const {
      image,
      name,
      tier,
      stage,
      strategySessionDate,
      platform,
      cms,
      launchDate,
      hardLaunchDate,
      estDevStart,
      comment,
      projectSOW,
      designSpec,
      techSpec,
      USPM,
      SLPM,
      BA,
    } = values;
    const submitData: any = {
      name,
      image,
      tier: typeof tier === 'object' ? tier.value : tier,
      stage: typeof stage === 'object' ? stage.value : stage,
      strategySessionDate,
      platform,
      cms: typeof cms === 'object' ? cms.value : cms,
      launchDate,
      hardLaunchDate,
      estDevStart,
      comment,
      projectSOW,
      designSpec,
      techSpec,
      USPM: typeof USPM === 'object' ? USPM.value : USPM,
      SLPM: typeof SLPM === 'object' ? SLPM.value : SLPM,
      BA: typeof BA === 'object' ? BA.value : BA,
    };
    if (prototypeId) {
      submitData.prototypeId = prototypeId;
    }
    let result;
    try {
      result = await prototypeApi.save(submitData);
    } catch (error) {
      toast(
        typeof (error as any).response?.data?.message === 'string'
          ? (error as any).response?.data?.message
          : 'Sorry. Error ocurred while processing request.',
        {
          type: 'error',
        },
      );
      return;
    }
    toast(
      prototypeId
        ? 'Prototype has been updated successfully'
        : 'Prototype has been created successfully',
      {
        type: 'success',
        autoClose: 3,
      },
    );

    submitProps.setSubmitting(false);
    submitProps.resetForm();
    if (!prototypeId) {
      history.push(
        `/prototype/create-page/${result.data.data.id}/${values.name}`,
      );
    } else {
      setPrototypeView(true);
      history.push(`/prototypes`);
      if (onClose) {
        onClose();
      }
    }
  };

  const validationSchema = Yup.object({
    name: Yup.string().required('Project name Required'),
    image: Yup.string().optional(),
    tier: Yup.string().required('Project tier Required'),
    stage: Yup.string().required('Project stage Required'),
    strategySessionDate: Yup.date()
      .nullable()
      .optional()
      .label('Strategy session date'),
    platform: Yup.string().optional(),
    cms: Yup.string().optional(),
    launchDate: Yup.date().nullable().optional().label('Launch date'),
    hardLaunchDate: Yup.boolean().optional().label('Hard launch date'),
    estDevStart: Yup.date().nullable().optional().label('Est. dev start'),
    comment: Yup.string().optional(),
    projectSOW: Yup.string().optional().url().label('Project SOW'),
    designSpec: Yup.string().optional().url().label('Design spec'),
    techSpec: Yup.string().optional().url().label('Tech spec'),
    USPM: Yup.string().optional(),
    SLPM: Yup.string().optional(),
    BA: Yup.string().optional(),
  });

  const handleUploadFile = useCallback(
    async (file, fileType) => {
      if (!file) return;

      setIsUpload(false);

      const form = new FormData();
      form.append('image', file);

      try {
        const uploadName = await prototypeApi.upload(
          form,
          fileType || 'prototype',
        );
        const imageUrl = uploadName.data.data;

        // Update both initialValues and formik values
        setInitialValues({
          ...initialValues,
          image: imageUrl,
        });

        // Update the formik form value directly
        if (formikRef.current) {
          formikRef.current.setFieldValue('image', imageUrl);
        }
      } catch (error) {
        toast('Error uploading image. Please try again.', {
          type: 'error',
        });
      } finally {
        setIsUpload(true);
      }
    },
    [initialValues, setInitialValues],
  );

  const setValue = useCallback(
    (options, values, element) => {
      const {
        image,
        name,
        tier,
        stage,
        strategySessionDate,
        platform,
        cms,
        launchDate,
        hardLaunchDate,
        estDevStart,
        comment,
        projectSOW,
        designSpec,
        techSpec,
        USPM,
        SLPM,
        BA,
      } = values;

      const prototype: { [key: string]: string | any } = {
        name,
        image,
        tier,
        stage,
        strategySessionDate,
        platform,
        cms,
        launchDate,
        hardLaunchDate,
        estDevStart,
        comment,
        projectSOW,
        designSpec,
        techSpec,
        USPM,
        SLPM,
        BA,
      };
      if (options) {
        prototype[element] = options;
        setInitialValues({ ...initialValues, ...prototype });
      } else {
        prototype[element] = '';
        setInitialValues({ ...initialValues, ...prototype });
      }
    },
    [initialValues, setInitialValues],
  );

  const getPrototype = async (id: string) => {
    try {
      const results = await prototypeApi.requestPrototypeById(id);
      const {
        image,
        name,
        tier,
        stage,
        strategySessionDate,
        platform,
        cms,
        launchDate,
        hardLaunchDate,
        estDevStart,
        comment,
        projectSOW,
        designSpec,
        techSpec,
        USPM,
        SLPM,
        BA,
      } = results.data.prototype;
      setInitialValues({
        image,
        name,
        tier: { value: tier, label: tier },
        stage: { value: stage, label: stage },
        strategySessionDate,
        platform,
        cms: cms ? { value: cms, label: cms } : '',
        launchDate,
        hardLaunchDate,
        estDevStart,
        comment,
        projectSOW,
        designSpec,
        techSpec,
        USPM: USPM ? { value: USPM, label: USPM } : '',
        SLPM: SLPM ? { value: SLPM, label: SLPM } : '',
        BA: BA ? { value: BA, label: BA } : '',
      });
    } catch (e) {
      if ((e as any).response && (e as any).response.status) {
        // eslint-disable-next-line no-console
        console.error('Something went wrong!');
      }
    }
  };
  const pageEdit = () => {
    setPrototypeView(false);
    history.push(`/prototype/create/${prototypeId}/`);
  };
  const cancelEdit = () => {
    if (onClose) {
      onClose();
    } else {
      setPrototypeView(true);
      history.push(`/prototypes`);
    }
  };
  useEffect(() => {
    if (prototypeId) {
      getPrototype(prototypeId);
    }
    if (view) {
      setPrototypeView(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  AddPrototype.defaultProps = {
    onClose: undefined,
  };

  return (
    <>
      <ModalHeader
        toggle={toggle}
        className="ar-edit-page__moodboard-popup-title ar-popup-close-btn"
      >
        <div className="container-fluid">
          <Row>
            <Col>
              {' '}
              {prototypeView
                ? 'View Prototype'
                : prototypeId
                ? 'Edit Prototype'
                : 'Create Prototype'}
            </Col>
          </Row>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="ar-common-form ar-common-form--fixed-max-width">
          <Formik
            innerRef={formikRef}
            enableReinitialize
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
          >
            {(formik) => {
              return (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    formik.handleSubmit();
                  }}
                >
                  <Row>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group">
                        <FormikControl
                          control="Input"
                          type="text"
                          name="name"
                          label="Project Name*"
                          disabled={prototypeView}
                        />
                      </div>
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group default-margin">
                        <DragAndDropField
                          previewStatus
                          className="ar-common-form__select"
                          uploading={!isUpload}
                          currentFileName={
                            formik.values.image ? formik.values.image : ''
                          }
                          name="image"
                          label="Cover Image"
                          validFileTypes={['png', 'jpg', 'jpeg']}
                          fileType="image"
                          handleUploadFile={handleUploadFile}
                        />
                        <ErrorMessage name="image">
                          {(msg) => (
                            <div className="error" style={{ marginTop: -25 }}>
                              {msg}
                            </div>
                          )}
                        </ErrorMessage>
                      </div>
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <label htmlFor="tier">Tier*</label>
                        <CreatableSelect
                          className="ar-common-form__select"
                          isClearable
                          classNamePrefix="rctslct"
                          name="tier"
                          inputId="tier"
                          options={SelectLists.tierList}
                          placeholder="tier"
                          onBlur={(e) => {
                            formik.handleBlur(e);
                          }}
                          onChange={(option) => {
                            setValue(option, formik.values, 'tier');
                          }}
                          backspaceRemovesValue={false}
                          value={formik.values.tier}
                          noOptionsMessage={() => 'No options available'}
                          isDisabled={prototypeView}
                        />
                        <ErrorMessage name="tier" component={TextError} />
                      </div>
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <label htmlFor="stage">Stage*</label>
                        <CreatableSelect
                          className="ar-common-form__select"
                          isClearable
                          classNamePrefix="rctslct"
                          name="stage"
                          inputId="stage"
                          options={SelectLists.stageList}
                          placeholder="stage"
                          onBlur={(e) => {
                            formik.handleBlur(e);
                          }}
                          onChange={(option) => {
                            setValue(option, formik.values, 'stage');
                          }}
                          backspaceRemovesValue={false}
                          value={formik.values.stage}
                          noOptionsMessage={() => 'No options available'}
                          isDisabled={prototypeView}
                        />
                        <ErrorMessage name="stage" component={TextError} />
                      </div>
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <FormikControl
                          label="Strategy Session Date"
                          control="DatePicker"
                          placeholder="select..."
                          name="strategySessionDate"
                          value={formik.values.strategySessionDate}
                          onChange={(v: any) => {
                            setValue(v, formik.values, 'strategySessionDate');
                          }}
                          disabled={prototypeView}
                        />
                      </div>
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <FormikControl
                          control="Input"
                          type="text"
                          setFieldValue={formik.setFieldValue}
                          name="platform"
                          label="Platform"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          disabled={prototypeView}
                        />
                      </div>
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <label htmlFor="cms">CMS</label>
                        <CreatableSelect
                          className="ar-common-form__select"
                          isClearable
                          classNamePrefix="rctslct"
                          name="cms"
                          inputId="cms"
                          options={SelectLists.cmsList}
                          placeholder="select..."
                          onBlur={(e) => {
                            formik.handleBlur(e);
                          }}
                          onChange={(option) => {
                            setValue(option, formik.values, 'cms');
                          }}
                          backspaceRemovesValue={false}
                          value={formik.values.cms}
                          noOptionsMessage={() => 'No options available'}
                          isDisabled={prototypeView}
                        />
                        <ErrorMessage name="cms" component={TextError} />
                      </div>
                    </Col>
                    <Col xs="10" md="12">
                      <div className="ar-common-form__group form-group">
                        <FormikControl
                          control="ToggleButton"
                          type="checkbox"
                          setFieldValue={formik.setFieldValue}
                          name="hardLaunchDate"
                          label="Hard launch Date"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          disabled={prototypeView}
                        />
                      </div>
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <FormikControl
                          label="Launch Date"
                          control="DatePicker"
                          placeholder="select..."
                          name="launchDate"
                          value={formik.values.launchDate}
                          onChange={(v: any) => {
                            setValue(v, formik.values, 'launchDate');
                          }}
                          disabled={prototypeView}
                        />
                      </div>
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <FormikControl
                          label="Est Dev Start"
                          control="DatePicker"
                          placeholder="select..."
                          name="estDevStart"
                          value={formik.values.estDevStart}
                          onChange={(v: any) => {
                            setValue(v, formik.values, 'estDevStart');
                          }}
                          disabled={prototypeView}
                        />
                      </div>
                    </Col>
                    <Col xs="10" md="12">
                      <div className="ar-common-form__group form-group">
                        <FormikControl
                          control="Textarea"
                          type="textarea"
                          setFieldValue={formik.setFieldValue}
                          name="comment"
                          label="Comment"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          disabled={prototypeView}
                        />
                      </div>
                    </Col>
                    <Col xs="10" md="12">
                      <hr />
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <FormikControl
                          control="Input"
                          type="url"
                          setFieldValue={formik.setFieldValue}
                          name="projectSOW"
                          label="Project SOW"
                          url={formik.values.projectSOW}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          disabled={prototypeView}
                        />
                      </div>
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <FormikControl
                          control="Input"
                          type="url"
                          setFieldValue={formik.setFieldValue}
                          name="designSpec"
                          label="Design Spec"
                          url={formik.values.designSpec}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          disabled={prototypeView}
                        />
                      </div>
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <FormikControl
                          control="Input"
                          type="url"
                          setFieldValue={formik.setFieldValue}
                          name="techSpec"
                          label="Tech Spec"
                          url={formik.values.techSpec}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          disabled={prototypeView}
                        />
                      </div>
                    </Col>
                    <Col xs="10" md="10">
                      <hr />
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <label htmlFor="US PM">US PM</label>
                        <CreatableSelect
                          className="ar-common-form__select"
                          isClearable
                          classNamePrefix="rctslct"
                          name="USPM"
                          inputId="USPM"
                          options={SelectLists.uspmList}
                          placeholder="select..."
                          onBlur={(e) => {
                            formik.handleBlur(e);
                          }}
                          onChange={(option) => {
                            setValue(option, formik.values, 'USPM');
                          }}
                          backspaceRemovesValue={false}
                          value={formik.values.USPM}
                          noOptionsMessage={() => 'No options available'}
                          isDisabled={prototypeView}
                        />
                        <ErrorMessage name="USPM" component={TextError} />
                      </div>
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <label htmlFor="SL PM">SL PM</label>
                        <CreatableSelect
                          className="ar-common-form__select"
                          isClearable
                          classNamePrefix="rctslct"
                          name="SLPM"
                          inputId="SLPM"
                          options={SelectLists.slpmList}
                          placeholder="select..."
                          onBlur={(e) => {
                            formik.handleBlur(e);
                          }}
                          onChange={(option) => {
                            setValue(option, formik.values, 'SLPM');
                          }}
                          backspaceRemovesValue={false}
                          value={formik.values.SLPM}
                          noOptionsMessage={() => 'No options available'}
                          isDisabled={prototypeView}
                        />
                        <ErrorMessage name="SLPM" component={TextError} />
                      </div>
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <label htmlFor="BA">BA</label>
                        <CreatableSelect
                          className="ar-common-form__select"
                          isClearable
                          classNamePrefix="rctslct"
                          name="BA"
                          inputId="BA"
                          options={SelectLists.baList}
                          placeholder="select..."
                          onBlur={(e) => {
                            formik.handleBlur(e);
                          }}
                          onChange={(option) => {
                            setValue(option, formik.values, 'BA');
                          }}
                          backspaceRemovesValue={false}
                          value={formik.values.BA}
                          noOptionsMessage={() => 'No options available'}
                          isDisabled={prototypeView}
                        />
                        <ErrorMessage name="BA" component={TextError} />
                      </div>
                    </Col>
                  </Row>
                </form>
              );
            }}
          </Formik>
        </div>
      </ModalBody>
      <ModalFooter>
        {prototypeId ? (
          prototypeView ? (
            <Button
              className="ar-btn ar-btn--light"
              onClick={pageEdit}
              type="button"
            >
              Update
            </Button>
          ) : (
            <Button
              className="ar-btn ar-btn--light"
              onClick={() => formikRef.current?.handleSubmit()}
              disabled={!isUpload}
              type="submit"
            >
              Update
            </Button>
          )
        ) : (
          <Button
            className="ar-btn ar-btn--light"
            onClick={() => formikRef.current?.handleSubmit()}
            disabled={!isUpload}
            type="submit"
          >
            Create
          </Button>
        )}
      </ModalFooter>
    </>
  );
};

export default AddPrototype;
